module.exports = __webpack_public_path__ + "static/img/AppleMusictoLMP.cb82e42.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/misc/1x/AppleMusictoLMP.png
// module id = jgVQ
// module chunks = 1